import React from 'react';
import PropTypes from 'prop-types';
import { QueryRenderer, graphql } from 'react-relay';
import ReactDom from 'react-dom';
import fuzzy from 'fuzzy';
import { StyleSheet, css } from 'aphrodite';

import environment from '../../relay/environment';
import ResponseListFilters from './ResponseListFilters';
import Response from './Response';

class RenderedResponses extends React.Component {
  static propTypes = {
    responses: PropTypes.arrayOf(PropTypes.object).isRequired,
    activeResponse: PropTypes.string,
  }

  static defaultProps = {
    activeResponse: '',
  }

  componentDidMount() {
    this.scrollToResponse();
  }

  componentDidUpdate() {
    this.scrollToResponse();
  }

  scrollToResponse = () => {
    const node = ReactDom.findDOMNode(this.refs.activeVendor); // eslint-disable-line
    if (node) {
      node.scrollIntoView({behavior: "instant", block: "start"});
    }
  }

  render() {
    const { responses, activeResponse } = this.props;

    return (<div className={css(styles.listItems)}>{responses.map((response) => {
      const { id: responseId } = response;
      const active = responseId === activeResponse;
      const ref = active ? 'activeResponse' : null;

      return (<Response key={responseId} response={response} active={active} ref={ref} />);
    })}</div>);
  }
}


export default class ResponseListRenderer extends React.Component { // eslint-disable-line
  static propTypes = {
    loadingEl: PropTypes.shape().isRequired,
    filter: PropTypes.string,
    activeResponse: PropTypes.string,
  }

  static defaultProps = {
    filter: '',
    activeResponse: null,
  }

  constructor(props) {
    super(props);
    this.state = {
      filter: props.filter,
    };
  }

  updateFilter = (e) => {
    const { target: { value: newFilter } } = e;
    this.setState({ filter: newFilter });
  }

  render() {
    const { loadingEl, activeResponse } = this.props;
    const { filter } = this.state;

    return (<QueryRenderer
      environment={environment} query={graphql`
        query ResponseListRenderer_ResponseList_Query {
          allResponses {
            edges {
              node {
                id,
                display,
                created
              }
            }
          }
        }
      `} render={({ error, props }) => {
        if (error) {
          return <div>{error.message}</div>;
        } else if (props) {
          const { allResponses: { edges: responses } } = props;

          let filteredResponses = responses.map(({ node }) => node);
          if (filter) {
            filteredResponses = fuzzy.filter(
              filter, responses.map(({ node }) => node), {
                extract: response => response.display,
              }
            ).map(filteredResponse => filteredResponse.original);
          }

          return (<div>
            <ResponseListFilters
              numTotal={responses.length}
              numFiltered={filteredResponses.length}
              updateFilter={this.updateFilter}
              filter={filter}
            />
            <RenderedResponses responses={filteredResponses} activeResponse={activeResponse} />
          </div>);
        }
        return loadingEl;
      }}
    />);
  }
}

const styles = StyleSheet.create({
  listItems: {
    height: 'calc(100vh - 161px)',
    overflow: 'auto',
    position: 'relative',
    top: '90px',
  },
});



// WEBPACK FOOTER //
// /src/components/Forms/ResponseListRenderer.js